// import * as StringTools from '~/utilities/string'
import EmailValidation from "~/utilities/emailValidation"

const LOGIN_VALIDATIONS = {
  email: (value) => {
    const emailLength = value.trim().length
    if (!value || !emailLength) return "Email is required"
    if (!EmailValidation(value))
      return "Please enter a valid email address containing no more than 4 characters after the last period."
    return false // No error
  },
  password: (value) => {
    const passwordLength = value.trim().length
    if (!value || !passwordLength) return "A password is required"
    if (passwordLength <= 3) {
      return "Password is not long enough"
    }
    return false // No error
  },
  loginCode: (value) => {
    const code = value.trim()
    if (!code) return "Login code is required"
    if (!/^\d{6}$/.test(code)) return "Enter the 6-digit code from your email"
    return false
  },
}

export default LOGIN_VALIDATIONS
